import styled from 'vue3-styled-components';

// 모달 오버레이
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

// 모달 컨테이너 (width 증가)
export const ModalContainer = styled.div`
  background: white;
  border-radius: 16px;
  width: 90%;
  max-width: 1200px;
  max-height: 85vh;
  overflow: hidden;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  animation: slideUp 0.3s ease-out;

  @keyframes slideUp {
    from {
      transform: translateY(20px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

// 모달 바디 그리드
export const ModalBodyGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  height: 100%;
  overflow: hidden;
`;

// 왼쪽 섹션
export const LeftSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px; // 24px에서 16px로 감소
`;

// 오른쪽 섹션
export const RightSection = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-left: 1px solid #e5e7eb;
  padding-left: 24px;
`;

// 모달 바디 (기존 스타일 수정)
export const ModalBody = styled.div`
  flex: 1;
  overflow: hidden;
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
`;

// 모달 헤더
export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  border-bottom: 1px solid #e5e7eb;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
`;

export const ModalTitle = styled.h2`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const MessageIcon = styled.span`
  font-size: 1.5rem;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`;

// 발신자 섹션
export const SenderSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

// 발신자 아바타
export const SenderAvatar = styled.div`
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.2);
`;

// 수신자 섹션
export const RecipientSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SectionTitle = styled.h3`
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #374151;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const RecipientAvatar = styled.div`
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.2);
`;

// 메시지 섹션
export const MessageSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const CharacterCount = styled.span`
  font-size: 0.85rem;
  color: #6b7280;
  font-weight: normal;
`;

export const MessageTextarea = styled.textarea`
  min-height: 150px;
  padding: 10px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  resize: vertical;
  font-size: 14px;
  line-height: 1.5;

  &:focus {
    outline: none;
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  }

  &::placeholder {
    color: #9ca3af;
  }

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 10px;
    margin: 4px 0;
  }

  &::-webkit-scrollbar-thumb {
    background: linear-gradient(135deg, #cbd5e1, #94a3b8);
    border-radius: 10px;
    border: 2px solid #f1f5f9;
    transition: all 0.2s ease;

    &:hover {
      background: linear-gradient(135deg, #94a3b8, #64748b);
      transform: scale(1.05);
    }

    &:active {
      background: linear-gradient(135deg, #64748b, #475569);
    }
  }

  &::-webkit-scrollbar-corner {
    background: #f1f5f9;
  }

  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 #f1f5f9;
`;

export const MessageTemplates = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;

export const TemplateButton = styled.button`
  background: white;
  border: 1px solid #d1d5db;
  color: #374151;
  padding: 6px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.8rem;
  transition: all 0.2s;

  &:hover {
    background: #f3f4f6;
    border-color: #667eea;
    color: #667eea;
  }
`;

// 모달 푸터
export const ModalFooter = styled.div`
  padding: 12px 20px;
  border-top: 1px solid #e5e7eb;
  background: #f8fafc;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const FooterButtons = styled.div`
  display: flex;
  gap: 12px;
`;

export const CancelButton = styled.button`
  background: white;
  border: 1px solid #d1d5db;
  color: #374151;
  padding: 7px 14px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s;

  &:hover {
    background: #f3f4f6;
  }
`;

export const SendButton = styled.button`
  background: #667eea;
  border: none;
  color: white;
  padding: 7px 14px;
  border-radius: 5px;
  cursor: pointer;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s;

  &:hover:not(:disabled) {
    background: #5a67d8;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }

  &.kakao {
    background: #fee500;
    color: #3c1e1e;

    &:hover:not(:disabled) {
      background: #fdd835;
    }
  }

  &.sms {
    background: #059669;

    &:hover:not(:disabled) {
      background: #047857;
    }
  }
`;

export const FileInput = styled.input`
  display: none;
`;

export const FileInputButton = styled.button`
  background: white;
  border: 1px solid #d1d5db;
  color: #374151;
  padding: 6px 12px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.2s;

  &:hover {
    background: #f3f4f6;
    border-color: #667eea;
    color: #667eea;
  }
`;

export const RemoveFileButton = styled.button`
  background: none;
  border: none;
  color: #ef4444;
  cursor: pointer;
  font-size: 1.2rem;
  padding: 0;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s;

  &:hover {
    background: #fee2e2;
  }
`;

export const FilePreview = styled.div`
  max-width: 200px; // 300px에서 200px로 감소
  max-height: 200px; // 300px에서 200px로 감소
  border: 1px solid #d1d5db;
  border-radius: 8px;
  overflow: hidden;

  img {
    width: 100%;
    height: auto;
    display: block;
  }
`;

// 연락처 정보 섹션 (발신자/수신자 한 줄)
export const ContactInfoSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

// 연락처 정보 행 (한 줄 배치)
export const ContactInfoRow = styled.div`
  display: flex;
  gap: 12px;
`;

// 발신자 카드 (아바타 제거)
export const SenderCard = styled.div`
  flex: 1;
  padding: 10px;
  background: #f0fdf4;
  border-radius: 12px;
  border: 1px solid #bbf7d0;
  transition: all 0.2s;

  &:hover {
    border-color: #667eea;
    box-shadow: 0 2px 8px rgba(102, 126, 234, 0.1);
  }
`;

// 발신자 정보
export const SenderInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

// 발신자 이름과 전화번호 행 (한 줄)
export const SenderNameRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

// 발신자 라벨
export const SenderLabel = styled.div`
  font-size: 13px;
  color: #059669;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

// 발신자 이름
export const SenderName = styled.div`
  font-weight: 600;
  color: #1f2937;
  font-size: 13px;
  margin-top: 5px;
`;

// 발신자 전화번호
export const SenderPhone = styled.div`
  color: #6b7280;
  font-size: 13px;
  margin-top: 5px;
`;

// 수신자 카드 (아바타 제거)
export const RecipientCard = styled.div`
  flex: 1;
  padding: 12px;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  transition: all 0.2s;

  &:hover {
    border-color: #667eea;
    box-shadow: 0 2px 8px rgba(102, 126, 234, 0.1);
  }
`;

// 수신자 정보
export const RecipientInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

// 수신자 이름과 전화번호 행 (한 줄)
export const RecipientNameRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

// 수신자 라벨
export const RecipientLabel = styled.div`
  font-size: 13px;
  color: #667eea;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

// 수신자 이름
export const RecipientName = styled.div`
  font-weight: 600;
  color: #1f2937;
  font-size: 13px;
  margin-top: 5px;
`;

// 수신자 전화번호
export const RecipientPhone = styled.div`
  color: #6b7280;
  font-size: 13px;
  margin-top: 5px;
`;

// 발송 방법 섹션
export const SendMethodSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

// 발송 방법 버튼들 (주제 아래에 버튼들 한 줄로)
export const MethodButtons = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 4px;  // 주제와 버튼 사이 간격
`;

// 발송 방법 버튼 (크기 조정)
export const MethodButton = styled.button`
  flex: 1;
  padding: 12px 16px;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  background: white;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.2s;

  &:hover {
    border-color: #9ca3af;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  &.active {
    border-color: #667eea;
    background: #eff6ff;
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
  }
`;

// 발송 방법 아이콘 (크기 조정)
export const MethodIcon = styled.div`
  font-size: 20px;
`;

// 발송 방법 텍스트
export const MethodText = styled.div`
  font-weight: 500;
  color: #374151;
  font-size: 0.9rem;
`;

// 파일 첨부 섹션
export const FileAttachmentSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px;
  background: #f8fafc;
  border-radius: 12px;
  /* 최대 높이를 더 작게 설정하여 푸터에 가려지지 않도록 */
  max-height: 400px;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

// 파일 첨부 섹션 내부 스크롤 영역
export const FileAttachmentContent = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;

  /* 웹킷 기반 브라우저 스크롤바 스타일링 */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 10px;
    margin: 4px 0;
  }

  &::-webkit-scrollbar-thumb {
    background: linear-gradient(135deg, #cbd5e1, #94a3b8);
    border-radius: 10px;
    border: 2px solid #f1f5f9;
    transition: all 0.2s ease;

    &:hover {
      background: linear-gradient(135deg, #94a3b8, #64748b);
      transform: scale(1.05);
    }

    &:active {
      background: linear-gradient(135deg, #64748b, #475569);
    }
  }

  &::-webkit-scrollbar-corner {
    background: #f1f5f9;
  }

  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 #f1f5f9;
`;

// 파일 첨부 헤더 (타이틀과 버튼 한 줄)
export const FileAttachmentHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

// 주문서 파일 목록
export const OrderFilesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
`;

// 주문서 파일 제목
export const OrderFilesTitle = styled.div`
  font-size: 0.85rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 4px;
`;

// 주문서 파일 아이템
export const OrderFileItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px;
  background: white;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  transition: all 0.2s;

  &:hover {
    border-color: #667eea;
    box-shadow: 0 2px 4px rgba(102, 126, 234, 0.1);
  }
`;

// 주문서 파일 체크박스
export const OrderFileCheckbox = styled.div`
  display: flex;
  align-items: center;

  input[type="checkbox"] {
    width: 15px;
    height: 15px;
    cursor: pointer;
  }
`;

// 주문서 파일 정보
export const OrderFileInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

// 주문서 파일명
export const OrderFileName = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: #1f2937;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

// 주문서 파일 등록일
export const OrderFileDate = styled.div`
  font-size: 12px;
  color: #6b7280;
`;

// 주문서 파일 미리보기 (이미지)
export const OrderFilePreview = styled.img`
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 6px;
  cursor: pointer;
  border: 1px solid #d1d5db;
`;

// 주문서 파일 아이콘 (PDF, 기타)
export const OrderFileIcon = styled.div`
  width: 40px;
  height: 40px;
  background: ${props => props.children === 'PDF' ? '#f44336' : '#9e9e9e'};
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  font-size: 0.7rem;
  font-weight: 600;
  cursor: pointer;
`;

// 사용자 파일 정보
export const UserFileInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
  padding: 8px;
  background: #eff6ff;
  border-radius: 8px;
  border: 1px solid #bfdbfe;
`;

// 사용자 파일 라벨
export const UserFileLabel = styled.div`
  font-size: 0.85rem;
  font-weight: 600;
  color: #1e40af;
`;

// 파일 정보 (기존)
export const FileInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #6b7280;
  font-size: 0.85rem;
  padding: 8px 12px;
  background: white;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  flex: 1;
`;

// 파일 도움말 텍스트
export const FileHelpText = styled.div`
  font-size: 13px;
  color: #6b7280;
  margin-top: 30px;
  text-align: center;
`;

// 파일 입력 래퍼 (제거 또는 수정)
export const FileInputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

export const LoadingSpinner = styled.div`
  width: 48px;
  height: 48px;
  border: 4px solid #e5e7eb;
  border-top-color: #007bff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin-bottom: 20px;
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

export const LoadingText = styled.div`
  font-size: 15px;
  font-weight: 400;
  color: #374151;
  letter-spacing: 0;
  line-height: 1.5;
`;

// 전송내역 버튼 섹션
export const HistoryButtonsSection = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  gap: 12px;
  margin-top: 10px;
  margin-bottom: 24px;
`;

// 문자 발송내역 버튼
export const HistoryButtonSms = styled.button`
    padding: 5px 10px;
    border-radius: 5px;
    cursor: pointer;
    border: none;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: #ffffff;
    font-size: 14px;
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
    display: flex;
    align-items: center;
    gap: 8px;
    white-space: nowrap;

    &:hover {
        background: linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%);
    }
`;

export const HistoryButtonFax = styled.button`
    padding: 5px 10px;
    border-radius: 5px;
    cursor: pointer;
    border: none;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: #ffffff;
    font-size: 14px;
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
    display: flex;
    align-items: center;
    gap: 8px;
    white-space: nowrap;

    &:hover {
        background: linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%);
    }
`;

export const HistoryButtonKakao = styled.button`
    padding: 5px 10px;
    border-radius: 5px;
    cursor: pointer;
    border: none;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: #ffffff;
    font-size: 14px;
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
    display: flex;
    align-items: center;
    gap: 8px;
    white-space: nowrap;

    &:hover {
        background: linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%);
    }
`;

// 팩스 번호 카드
export const FaxNumberCard = styled.div`
  flex: 1;
  padding: 12px;
  background: #fff7ed;
  border-radius: 12px;
  border: 1px solid #fed7aa;
  transition: all 0.2s;

  &:hover {
    border-color: #667eea;
    box-shadow: 0 2px 8px rgba(102, 126, 234, 0.1);
  }
`;

// 팩스 번호 정보
export const FaxNumberInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

// 팩스 번호 라벨
export const FaxNumberLabel = styled.div`
  font-size: 13px;
  color: #ea580c;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

// 팩스 번호 입력 필드
export const FaxNumberInput = styled.input`
  width: 80%;
  padding: 6px 8px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  color: #1f2937;
  transition: all 0.2s;
  background: white;

  &:focus {
    outline: none;
    border-color: #ea580c;
    box-shadow: 0 0 0 3px rgba(234, 88, 12, 0.1);
  }

  &::placeholder {
    color: #9ca3af;
  }

  &:disabled {
    background: #f3f4f6;
    color: #9ca3af;
    cursor: not-allowed;
    opacity: 0.6;
  }
`;